import {
  MODEL_DISCLAIMER,
  formatModelScore,
  formatPredictionTypeLabel,
} from "../../../constants/environmentalModelLayers";
import { formatRiskLevel } from "../../../utils/environmentalRiskFormatting";

const PropertyEnvironmentalModelCard = ({ environmentalModel }) => {
  if (!environmentalModel?.available) {
    return null;
  }

  const { flood, landslide, stormSeverity, infrastructureDisruption } = environmentalModel;

  return (
    <section className="panel-card property-environmental-model">
      <p className="eyebrow">Environmental Modeling</p>
      <h3>Model signals</h3>
      <p className="muted">{MODEL_DISCLAIMER}</p>

      <dl className="forecast-cards__grid">
        <div className="forecast-cards__card">
          <dt>Flood indicator</dt>
          <dd>{formatModelScore(flood?.probabilityScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Slope indicator</dt>
          <dd>{formatModelScore(landslide?.probabilityScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Storm exposure</dt>
          <dd>{formatModelScore(stormSeverity?.probabilityScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Infrastructure signal</dt>
          <dd>{formatModelScore(infrastructureDisruption?.probabilityScore)}</dd>
        </div>
      </dl>

      {[flood, landslide, stormSeverity, infrastructureDisruption]
        .filter(Boolean)
        .slice(0, 2)
        .map((prediction) => (
          <div key={prediction.predictionType} className="property-environmental-model__detail">
            <strong>{formatPredictionTypeLabel(prediction.predictionType)}</strong>
            <span className="muted">
              {formatRiskLevel(prediction.riskLevel)} · confidence{" "}
              {formatModelScore(prediction.confidenceScore)}
            </span>
            {prediction.topFactors?.length ? (
              <ul>
                {prediction.topFactors.slice(0, 3).map((factor) => (
                  <li key={factor.factorName}>{factor.explanation || factor.factorName}</li>
                ))}
              </ul>
            ) : null}
          </div>
        ))}
    </section>
  );
};

export default PropertyEnvironmentalModelCard;
